import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: '/yoyaku/',
	routes: [
		{
			path: '/',
			name: 'Index',
			redirect: { name: 'Step1' }
		},
		{
			path: '/index.html',
			name: 'Step1',
			component: () => import('@/views/step1')
		},
		{
			path: '/input.html',
			name: 'Step2',
			component: () => import('@/views/step2')
		},
		{
			path: '/confirm.html',
			name: 'Step3',
			component: () => import('@/views/step3')
		},
		{
			path: '/thanks',
			name: 'Step4',
			component: () => import('@/views/step4')
		},
		{
			path: '*',
			name: '404',
			beforeEnter(to, from, next) {
				next('/index.html')
			}
//			redirect: { name: 'Step1' }
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js